import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tanium/react-box';
import { MediumSubtleText, PageTitleText } from '../../TextStyles';

export const PortalHeading: React.VFC = () => {
  const { t } = useTranslation();
  return (
    <Box mb={4}>
      <PageTitleText>{t('Tanium Account')}</PageTitleText>
      <MediumSubtleText>{t('Manage your Tanium entitlements and service access')}</MediumSubtleText>
    </Box>
  );
};
